export const ENQUIRY_PAGE_SIZES = [10, 20, 50, 100];

export const ENQUIRY_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "name_asc", label: "Name: A–Z" },
  { value: "status", label: "Status" },
];

function getSearchHaystack(enquiry) {
  return [enquiry.name, enquiry.email, enquiry.phone, enquiry.message, enquiry.status]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function compareEnquiries(a, b, sortBy) {
  switch (sortBy) {
    case "oldest":
      return new Date(a.createdAt) - new Date(b.createdAt);
    case "name_asc":
      return String(a.name || "").localeCompare(String(b.name || ""), undefined, {
        sensitivity: "base",
      });
    case "status":
      return String(a.status || "").localeCompare(String(b.status || ""));
    case "newest":
    default:
      return new Date(b.createdAt) - new Date(a.createdAt);
  }
}

export function filterAndSortEnquiries(enquiries, filters) {
  const {
    search = "",
    status = "all",
    dateFrom = "",
    dateTo = "",
    sortBy = "newest",
  } = filters;

  const query = search.trim().toLowerCase();
  const fromTime = dateFrom ? new Date(`${dateFrom}T00:00:00`).getTime() : null;
  const toTime = dateTo ? new Date(`${dateTo}T23:59:59.999`).getTime() : null;

  const filtered = (enquiries || []).filter((enquiry) => {
    if (status !== "all" && enquiry.status !== status) return false;

    if (fromTime || toTime) {
      const received = new Date(enquiry.createdAt).getTime();
      if (fromTime && received < fromTime) return false;
      if (toTime && received > toTime) return false;
    }

    if (query && !getSearchHaystack(enquiry).includes(query)) return false;
    return true;
  });

  return [...filtered].sort((a, b) => compareEnquiries(a, b, sortBy));
}
